import { Divider as MuiDivider, styled, Typography } from '@mui/material';

export const Divider = styled(MuiDivider)(() => ({
  borderColor: 'transparent',
  margin: '12px 10px',
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: '8px 10px 4px',
  padding: '8px 12px',
  fontSize: '13px',
  fontWeight: 600,
  letterSpacing: '0.03em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));

export const SkeletonRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  margin: '5px 10px',
  padding: '5px 12px',
  minHeight: '48px',
}));
